import type { FC } from 'react'
import { useRouter } from 'next/router'
import dynamic from 'next/dynamic'
import StandardDealsList from '../../shared/deal-thumbnails/square/StandardDealsList'
import BrowseDealsHeader from './BrowseDealsHeader'
import { useFilteredDeals } from '../hooks/useFilteredDeals'
import PlaceholderKorag from '@g4g/ui/src/internal/PlaceholderKorag'
import Spinner from '@g4g/ui/src/internal/Spinner'
import { MinimalistButton } from '@g4g/ui/src/internal/buttons/MinimalistButton'
import NoResultsKorag from '../../shared/NoResultsKorag'
const AddToCartConfirmation = dynamic(
  () => import('../../shopping-cart/confirmation/AddToCartConfirmation')
)

const BrowseDealsError: FC = () => {
  const router = useRouter()

  return (
    <PlaceholderKorag
      callToAction={
        <MinimalistButton
          data-cy="shop-reload-page-btn"
          props={{
            mainColor: 'white',
            buttonText: 'Try Again',
            onClick: () => router.reload(),
          }}
        />
      }
    >
      <span className="px-4 text-rose-500">Something went wrong when trying to fetch deals</span>
    </PlaceholderKorag>
  )
}

const BrowseDealsSectionList: FC = () => {
  const { data: deals, error, loading } = useFilteredDeals()

  if (loading) {
    return (
      <div className="flex justify-center w-full mt-4 text-white">
        <Spinner className="w-6 h-6 sm:w-12 sm:h-12" delay={500} />
      </div>
    )
  }

  if (error) {
    return <BrowseDealsError />
  }

  return (
    <div className="flex flex-wrap mb-12 space-y-4 md:space-y-0">
      {deals.length > 0 ? (
        <StandardDealsList items={deals} />
      ) : (
        <NoResultsKorag
          heading="Sorry, your filter produced no results"
          subtext="Try adjusting the filters to widen your search"
        />
      )}
    </div>
  )
}

const BrowseDealsSection: FC = () => (
  <div>
    <AddToCartConfirmation />
    <BrowseDealsHeader />
    <BrowseDealsSectionList />
  </div>
)

export default BrowseDealsSection
